import React              from 'react'
import { observer }       from 'mobx-react'
import { SubmitButton }   from '../Common'
import ResetPasswordAlert from './ResetPasswordAlert'
import store, { STEPS }   from 'stores/ResetPasswordStore'
import { Form, Radio }    from 'antd'

const FormItem = Form.Item
const RadioGroup = Radio.Group

@observer
class DeliveryForm extends React.Component {
  componentDidMount() {
    store.setUserId(this.props.match.params.userId)
  }

  componentWillUnmount() {
    store.resetError()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        store.sendDeliveryMethod(values.delivery)
      }
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form

    return (
      <Form onSubmit={this.handleSubmit}>
        {store.showError && (
          <ResetPasswordAlert
            message={store.errorTitle}
            description={store.errorMessage}
            type="error"
            className="mb-4"
            closable
          />
        )}
        <p className="mb-4" style={{fontSize: '16px', fontWeight: '400'}}>
          Select a delivery method for your temporary password
        </p>
        <FormItem className="mb-4">
          {getFieldDecorator('delivery', {
            initialValue: 'email',
            rules:        [
              {
                required: true,
                message:  'Please select a delivery method'
              }
            ]
          })(
            <RadioGroup onChange={this.handleOnChange}>
              <Radio value="email">E-mail</Radio>
              <Radio value="sms">Text Message</Radio>
            </RadioGroup>
          )}
        </FormItem>
        <FormItem>
          <SubmitButton
            className="mr-2"
            style={{borderRadius: '8px'}}
            size="lg"
            onClick={() =>
              store.setCurrentStep(STEPS.USERNAME_VERIFICATION)
            }
            width="49%"
          >
            Previous
          </SubmitButton>

          <SubmitButton
            loading={store.isSendingConfirmationCode}
            size="lg"
            style={{backgroundColor: 'black', color: 'white', borderRadius: '8px', fontSize: '14px'}}
            width="49%"
          >
            {store.isSendingConfirmationCode
              ? 'Sending...'
              : 'Send Temporary Password'}
          </SubmitButton>
        </FormItem>
      </Form>
    )
  }
}

const WrappedDeliveryForm = Form.create()(DeliveryForm)

export default WrappedDeliveryForm
